import React from 'react';
import { Avatar, AvatarProps } from '@mui/material';

interface UserAvatarProps extends Omit<AvatarProps, 'children'> {
  user: {
    name: string;
    profileImage?: string;
  };
  size?: number;
}

const UserAvatar: React.FC<UserAvatarProps> = ({ 
  user, 
  size = 40, 
  sx, 
  ...props 
}) => {
  const getInitials = (name: string): string => {
    const names = name.trim().split(' ');
    if (names.length === 1) {
      return names[0]?.charAt(0).toUpperCase() || 'U';
    }
    // Para múltiplos nomes, usar primeira letra do primeiro nome + primeira letra do último nome
    const firstInitial = names[0]?.charAt(0) || '';
    const lastInitial = names[names.length - 1]?.charAt(0) || '';
    return (firstInitial + lastInitial).toUpperCase();
  };

  const avatarSx = {
    width: size,
    height: size,
    fontSize: size * 0.4,
    fontWeight: 'bold',
    backgroundColor: 'primary.main',
    color: 'white',
    ...sx
  };

  if (user.profileImage) {
    return (
      <Avatar
        src={user.profileImage}
        alt={user.name}
        sx={{
          ...avatarSx,
          '& img': {
            objectFit: 'contain',
            width: '100%',
            height: '100%'
          }
        }}
        {...props}
      />
    );
  }

  return (
    <Avatar
      sx={avatarSx}
      {...props}
    >
      {getInitials(user.name)}
    </Avatar>
  );
};

export default UserAvatar;
